var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 15.1673H5.99967C2.37967 15.1673 0.833008 13.6207 0.833008 10.0007V6.00065C0.833008 2.38065 2.37967 0.833984 5.99967 0.833984H9.99967C13.6197 0.833984 15.1663 2.38065 15.1663 6.00065V10.0007C15.1663 13.6207 13.6197 15.1673 9.99967 15.1673ZM5.99967 1.83398C2.92634 1.83398 1.83301 2.92732 1.83301 6.00065V10.0007C1.83301 13.074 2.92634 14.1673 5.99967 14.1673H9.99967C13.073 14.1673 14.1663 13.074 14.1663 10.0007V6.00065C14.1663 2.92732 13.073 1.83398 9.99967 1.83398H5.99967Z",
    fill: "#39AF26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05297 10.3858C6.91964 10.3858 6.79297 10.3324 6.69964 10.2391L4.81297 8.35242C4.61964 8.15909 4.61964 7.83909 4.81297 7.64576C5.0063 7.45242 5.3263 7.45242 5.51964 7.64576L7.05297 9.17909L10.4796 5.75242C10.673 5.55909 10.993 5.55909 11.1863 5.75242C11.3796 5.94576 11.3796 6.26575 11.1863 6.45909L7.4063 10.2391C7.31297 10.3324 7.1863 10.3858 7.05297 10.3858Z",
    fill: "#39AF26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.6e41f391b03f7c741ba87efbdb85ef58.svg";
export { ForwardRef as ReactComponent };